/** 解析券面值（normalizeUserCoupon 的 amount 字段） */
export function parseVoucherFaceAmount(item) {
  if (!item) return NaN;
  const n = parseFloat(String(item.amount ?? "").replace(/,/g, ""));
  return Number.isFinite(n) ? n : NaN;
}

/** 券面值是否在策略可下单区间内（与 Amount range 文案一致，含边界） */
export function isVoucherAmountInFollowRange(amountNum, minIn, maxIn) {
  if (!Number.isFinite(amountNum) || amountNum <= 0) return false;
  const min = Number(minIn);
  const max = Number(maxIn);
  if (Number.isFinite(min) && amountNum < min - 1e-8) return false;
  if (Number.isFinite(max) && amountNum > max + 1e-8) return false;
  return true;
}

export function isVoucherItemSelectableForFollow(item, minIn, maxIn) {
  return isVoucherAmountInFollowRange(parseVoucherFaceAmount(item), minIn, maxIn);
}
